import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { Card, Tabs } from '@reveni-io/reveni-ui'

import NestedRouteTitle from '@/common/components/NestedRouteTitle/NestedRouteTitle'
import TitlePage from '@/common/components/TitlePage/TitlePage'
import AppContext from '@/common/context/app.context'
import useTabs from '@/common/hooks/useTabs/useTabs'

import { getTabs } from './helpers'
import * as Styles from './styles'

const AccountPage = () => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)
  const tabs = getTabs(t, info.selectedStore.provider)
  const { tabSelected, onSelectTab } = useTabs({ tabs })

  return (
    <Styles.Container>
      <TitlePage>{t('Cuenta')}</TitlePage>
      <div>
        <Styles.TabContainer>
          <Tabs elements={tabs} onChange={onSelectTab} selected={tabSelected} />
          <Styles.TabContent>
            <Card showShadow={false}>
              <NestedRouteTitle tabSelected={tabSelected} tabs={tabs} />
              <Outlet />
            </Card>
          </Styles.TabContent>
        </Styles.TabContainer>
      </div>
    </Styles.Container>
  )
}

export default AccountPage
